import { render, staticRenderFns } from "./SchemaField.vue?vue&type=template&id=65d68bbe&scoped=true&"
import script from "./SchemaField.vue?vue&type=script&setup=true&lang=js&"
export * from "./SchemaField.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SchemaField.vue?vue&type=style&index=0&id=65d68bbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d68bbe",
  null
  
)

export default component.exports